import { render, staticRenderFns } from "./ModalQuoteTransfer.vue?vue&type=template&id=02436086&"
import script from "./ModalQuoteTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalQuoteTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports